import { ref } from 'vue'
import { getHeadersWithToken, handleResponse } from '@/utils/http'

// function wait(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms))
// }

// function getRandomNumber(min, max) {
//   return Math.floor(Math.random() * (max - min + 1)) + min
// }

export const api = {
  fetchOrdersAbortController: ref(new AbortController()),

  cancelFetchOrders() {
    api.fetchOrdersAbortController.value.abort()
  },

  async fetchOrders({ locationId }) {
    const endpoint = route('api.tables.fulfillments.index')

    api.fetchOrdersAbortController.value = new AbortController()

    const resp = await fetch(endpoint, {
      signal: api.fetchOrdersAbortController.value.signal,
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({
        filterModel: {
          fulfillment_location_id: {
            filterType: 'text',
            type: 'equals',
            filter: locationId
          }
        }
      })
    })

    return handleResponse('fetch', resp)
  },

  async fulfillOrderItems(id, items) {
    // await wait(getRandomNumber(300, 5000))
    // throw new Error('Failed to fulfill order')

    const endpoint = route('api.fulfillments.fulfill', id)

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify(items)
    })

    return handleResponse('fulfill', resp)
  },

  async fetchOrder(id) {
    const endpoint = route('api.fulfillments.show', { id })

    const resp = await fetch(endpoint, {
      method: 'GET',
      headers: getHeadersWithToken()
    })

    return handleResponse('fetch', resp)
  },

  async searchFulfillmentItems(orderId, productId, query, signal) {
    const endpoint = route('api.fulfillments.search', { id: orderId })

    console.log('searchFulfillmentItems', endpoint, query)

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ query, product_id: productId }),
      signal: signal
    })

    return handleResponse('search', resp)
  },

  async completeOrder(orderId, notify = false) {
    const endpoint = route('api.fulfillments.complete', { id: orderId })

    const resp = await fetch(endpoint, {
      method: 'PUT',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ send_notification: notify })
    })

    return handleResponse('complete', resp)
  },

  async verifyOrder(orderId) {
    const endpoint = route('api.orders.verify', { id: orderId })

    const resp = await fetch(endpoint, {
      method: 'PUT',
      headers: getHeadersWithToken()
    })

    return handleResponse('verify', resp)
  },

  async finalizeCancelOrder(orderId, notify = false) {
    const endpoint = route('api.fulfillments.cancel', { id: orderId })

    const resp = await fetch(endpoint, {
      method: 'PUT',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ send_notification: notify })
    })

    return handleResponse('cancel', resp)
  },

  async cancelOrders(orderIds) {
    const endpoint = route('api.orders.cancel')

    const resp = await fetch(endpoint, {
      method: 'PUT',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ orders: orderIds })
    })

    return handleResponse('cancel', resp)
  },

  async notifyOrders(orderIds) {
    const endpoint = route('api.fulfillments.notify')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ orders: orderIds })
    })

    return handleResponse('notify', resp)
  }
}
